
import styles from './index.less'
import Prescribible from "../../../asset/img/login/Prescribible.png";
import selfSupport from "../../../asset/img/login/self-support.png";
import Triple from "../../..//asset/img/login/Triple-A.png";
import { onClickhref } from 'utils';
 
const RecommendedDoc = (props: any) => {
    const { item, icon_right } = props;
    console.log(item, '来来来来来了 ------->');
    
    const onClickOpen = (url?: any) => {
      if (url) {
        window.open(url);
      } else {
        if (window.location.origin.indexOf("cont.jd") != -1) {
          window.open("https://cont.jd.com");
        } else {
          window.open("/");
        }
      }
    };
    const operationalOpenRxStatus = () => {
          item?.doctorInfo.doctorTagList.find((item:any) => {
          });
    };

    return  (
            <div
              key={item?.lowestSku}
              className={styles.doctorInfo}
              onClick={() => {
                if (item.doctorId) {
                  setTimeout(() => {
                    onClickOpen(
                      window.location.origin + "/doctor/" + item.doctorId
                    );
                  }, 200);
                }
              }}
            >
              <div className={styles.doctorInfoImg}>
                <img
                  src={
                    "https://image.healthjd.com/nethpim/" +
                    item?.doctorInfo.doctorHeadPic
                  }
                  alt={item?.doctorInfo.doctorName}
                />
                <div className={styles.doctorInfoImgRight}>
                  <div className={styles.doctorInfoImgTop}>
                   { item?.doctorInfo.doctorTagList?.map((item : any) => {
                      const tagStyle: any = { 
                        backgroundColor:"rgba(0,180,196,0.1)",
                      };
                     // 三甲 
                     if (item?.tagField == "hospitalGradeId") { 
                      tagStyle.border = "1px solid rgba(0,180,196,1)"
                     }
                     if (item?.tagField == "openRx") {
                      tagStyle.border = "1px solid rgba(0,180,196,1)"
                    }
                    if (item?.tagField == "10139") {
                      tagStyle.background = "linear-gradient(232.2deg, rgba(254,84,38,1) 0%,rgba(254,84,34,1) 100%)"
                      tagStyle.color = "#ffffff"
                    }
                      return <span className={styles.tagSpan} style={tagStyle}>{item.tagContent}</span>
                    })
                  }
                    <div className={styles.doctorInfoImgTopName1}>
                      {item?.doctorInfo.doctorName +
                        ":" +
                        window.location.origin +
                        "/doctor/" +
                        item.doctorId}
                    </div>
                    <div
                      className={styles.doctorInfoImgTopName}
                      data-a-href={ "/doctor/" + item.doctorId
                      }
                    >
                      {item?.doctorInfo.doctorName}
                    </div>
                    <span className={styles.titleSpan}>{item?.doctorInfo.doctorTitleName}</span>
                  </div>
                  <div className={styles.doctorInfoImgBotton}>
                    <p>
                      <a onClick={(e) => {
                        e.stopPropagation();
                        onClickhref(`/hospital/${item?.hospitalInfo?.hospitalId}`)
                      }}
                       data-a-href={`/hospital/${item?.hospitalInfo?.hospitalId}`}
                      >
                        {item?.hospitalInfo?.hospitalName}
                      </a>
                      {' '}
                      <a onClick={(e) => {
                        e.stopPropagation();
                        onClickhref(`/hospital/department/${item?.hospitalInfo?.hospitalId}-${item?.hospitalInfo?.secondDepartId}`)
                        }}
                        data-a-href={`/hospital/department/${item?.hospitalInfo?.hospitalId}-${item?.hospitalInfo?.secondDepartId}`}
                        >
                        {item?.hospitalInfo.secondDepartName}
                      </a>
                    </p>
                    <div className={styles.doctorInfoImgBotton1}>
                      <a href=""
                      data-a-href={ "/doctor/" + item.doctorId }
                      >{item?.hospitalInfo.hospitalName}
                      </a>
                       {item?.hospitalInfo.secondDepartName}
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.doctorInfoText1}>
                擅长: {item?.goodAtInfo.doctorGoodAt}
              </div>
              <div className={styles.doctorInfoText}>
                擅长: {item?.goodAtInfo.doctorGoodAt || "无"}
              </div>
         <div className={styles.feedbackInfoDiv}>
          <div >
            {'好评率:'}
            <span style={{ marginLeft: 10 }}>
              {item?.feedbackInfo.patientEvaluationRate}
            </span>
          </div>

          <div >
            {' 接诊人数:'}
            <span style={{ marginLeft: 10 }}>
              {item?.feedbackInfo.receivePatientNum}
            </span>
          </div>

          <div className={styles.toConsultation}>
            <span
              // data-a-href={
              //   // "/qa/" + itme?.contentDiags[0]?.diagId
              // }
              // data-a-nofollow="true"
            >
              立即咨询
            </span>
            <img src={icon_right} alt="" />
          </div>
        </div>
            </div>
          );
};

export default RecommendedDoc;